import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import type { AppDispatch } from "./store"
import { RootState } from "./rootReducer"
import { AnyAction, createAsyncThunk, ThunkAction } from "@reduxjs/toolkit"

// Use throughout your app instead of plain `useAppDispatch` and `useAppSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
    state: RootState
    dispatch: AppDispatch
}>()

export function createAppThunk<Arg, Returned>(
    payloadCreator: (
        arg: unknown extends Arg ? void : Arg,
        thunkAPI: { getState: () => RootState; dispatch: AppDispatch }
    ) => Returned
) {
    return (
        arg: unknown extends Arg ? void : Arg
    ): ThunkAction<Returned, RootState, undefined, AnyAction> =>
        (dispatch, getState) => {
            const thunkApi = {
                dispatch: dispatch,
                getState,
            }

            return payloadCreator(arg, thunkApi)
        }
}
